import { render, staticRenderFns } from "./BNPL_Dashboard.vue?vue&type=template&id=ed38d850&scoped=true&"
import script from "./BNPL_Dashboard.vue?vue&type=script&lang=js&"
export * from "./BNPL_Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed38d850",
  null
  
)

export default component.exports